import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import configureStore from "../store";
import { Provider, useDispatch, useSelector } from "react-redux";
import { useGetMerchantsQuery } from "../stores/paylaterAPI";
import "./index.css";
import { SelectList } from "./Component";
// import Dropdown from "react-bootstrap/Dropdown";
import Select from "react-select";
import {
  setMerchants,
  setSelectedCategory,
  setSelectedSubCategory,
  filterCategory,
  filterSubCategory,
  setSearch,
  clearSearch,
  unselectedCategory,
} from "../stores/paylaterSlice";
import Modal from "react-modal";
import { WORDS } from "./constanst";
import $ from "jquery";
// import "select2";
import tippy from "tippy.js";
import "magnific-popup";
import { object } from "underscore";
const store = configureStore();

// const $ = window.$;
const options = [
  { value: "chocolate", label: "Chocolate" },
  { value: "strawberry", label: "Strawberry" },
  { value: "vanilla", label: "Vanilla" },
];

const App = () => {
  const dispatch = useDispatch();
  const [endIndex, setEndIndex] = useState(20);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [endIndexPopular, setEndIndexPopular] = useState(20);
  const [hasMoreItemsPopular, setHasMoreItemsPopular] = useState(true);
  const [isLoadingMorePopular, setIsLoadingMorePopular] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const [showMerchant, setShowMerchant] = useState(null);
  const [isClickOutSide, setIsClickOutSide] = useState(false);

  const [showBar3, setShowBar3] = useState(true);

  const {
    categories,
    subcategories,
    // cate_logo,
    default_popular,
    merchants,
    selected_category,
    selected_subcategory,
    filter_popular_merchants,
    filter_merchants,
    search,
  } = useSelector((state) => state.paylater);

  const { data, error, isLoading, isError } = useGetMerchantsQuery();
  const selectRef = useRef(null);

  useEffect(() => {
    if (data && merchants.length == 0) {
      dispatch(setMerchants(data));
    }
  }, [data, merchants]);

  useEffect(() => {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    const getApp = urlParams.get("app");

    if(getApp !== null && getApp.toLocaleLowerCase() == "kplus_info")
    {
      setShowBar3(false);
    }else if(getApp !== null && getApp.toLocaleLowerCase() == "kplus")
    {
      setShowBar3(false);
    }
  }, []);

  const tooltipRef = useRef(null);
  const toggleRef = useRef(null);
  const tippyInstanceRef = useRef(null);

  const alertPopup = $(".alert-to-map");
  // const selectRef = useRef(null);

  useEffect(() => {
    // const content = document.getElementById("categoryTabToggleContent");
    if (toggleRef.current == null) {
      return;
    }
    const content = toggleRef.current;
    // toggleRef = toggleRef.current;
    content.style.display = "block";

    let leftPos = 0;
    let currentTab = 0;
    let countTimeClick = 0;

    const toggle = document.getElementById("categoryTabToggle");

    const instance = tippy("#categoryTabToggle .category-tab-toggle-button", {
      interactive: true,
      content: content,
      maxWidth: "none",
      allowHTML: true,
      offset: [0, 8],
      arrow: false,
      trigger: "click",
      placement: "bottom",
      onShow(instance) {
        toggle.querySelector(".category-tab-toggle-active-label").classList.add("active");
        let idx = $("#category-nav .kp-nav-item .kp-nav-link.active").parent().index() + 1;
        content.querySelector("li:nth-of-type(" + idx + ")");
        // .classList.add("active");
        $(".kp-nav").addClass("opa");
      },
      onHide(instance) {
        toggle.querySelector(".category-tab-toggle-active-label").classList.remove("active");
        let count = 0;
        content.querySelectorAll("li").forEach((_li) => {
          // _li.classList.remove("active");
          count = count + $(_li).outerWidth();
        });

        $(".kp-nav").removeClass("opa");

        let currentTab = $("#category-nav .kp-nav-item .kp-nav-link.active").parent().index();
        for (let i = 0; i < currentTab; i++) {
          leftPos = leftPos + $("#category-nav .kp-nav-item").eq(i).width();
        }

        $(".simplebar-content-wrapper").animate({ scrollLeft: leftPos }, 400);
        leftPos = 0;
      },
    });

    tippyInstanceRef.current = instance;
    // instance.destroy();

    new SimpleBar(document.querySelector("#category-nav"), {
      autoHide: false,
      forceVisible: false,
    });
  }, [toggleRef.current]);

  useEffect(() => {
    const nextEndIndex = endIndex;
    const totalItems = filter_merchants?.length > 0 ? filter_merchants?.length : merchants?.length;

    // Check if there are more items to fetch
    const hasMoreData = nextEndIndex <= totalItems;
    if (searchTerm != "" && filter_merchants?.length == 0) {
      setHasMoreItems(false);
    } else {
      setHasMoreItems(hasMoreData);
    }

    const nextEndIndexPop = endIndexPopular;
    const totalItemsPop = filter_popular_merchants
      ? filter_popular_merchants?.length
      : default_popular?.length;
    // Check if there are more items to fetch
    const hasMoreDataPop = nextEndIndexPop <= totalItemsPop;
    setHasMoreItemsPopular(hasMoreDataPop);
  }),
    [filter_merchants, filter_popular_merchants, default_popular];

  const handleLoadMore = async () => {
    if (hasMoreItems && !isLoadingMore) {
      setIsLoadingMore(true);

      try {
        // Perform the data fetching or any other async operation here
        // For example, you can dispatch an action to fetch more data from the server

        // Simulate an asynchronous operation with a delay
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Once the data is fetched, update the endIndex and set isLoadingMore to false
        const nextEndIndex = endIndex + 20;
        setEndIndex(nextEndIndex);
        const totalItems =
          filter_merchants?.length > 0 ? filter_merchants?.length : merchants?.length;
        // Check if there are more items to fetch
        const hasMoreData = nextEndIndex <= totalItems; // Replace 'totalItems' with the total number of items available
        setHasMoreItems(hasMoreData);

        setIsLoadingMore(false);
      } catch (error) {
        console.log("Error:", error);
        setIsLoadingMore(false);
      }
    }
  };

  const handleLoadMorePopular = async () => {
    if (hasMoreItemsPopular && !isLoadingMorePopular) {
      setIsLoadingMorePopular(true);

      try {
        // Perform the data fetching or any other async operation here
        // For example, you can dispatch an action to fetch more data from the server

        // Simulate an asynchronous operation with a delay
        await new Promise((resolve) => setTimeout(resolve, 2000));

        // Once the data is fetched, update the endIndex and set isLoadingMore to false
        const nextEndIndex = endIndex + 20;
        setEndIndexPopular(nextEndIndex);
        const totalItems = filter_popular_merchants
          ? filter_popular_merchants?.length
          : default_popular?.length;
        // Check if there are more items to fetch
        const hasMoreData = nextEndIndex <= totalItems; // Replace 'totalItems' with the total number of items available
        setHasMoreItemsPopular(hasMoreData);

        setIsLoadingMorePopular(false);
      } catch (error) {
        console.log("Error:", error);
        setIsLoadingMorePopular(false);
      }
    }
  };

  function handleSelectCategory(name) {
    if (selected_category != name) {
      dispatch(setSelectedCategory(name));
      dispatch(filterCategory(name));
      setEndIndex(20);
    }
    if (name == categories[0].cate_th) {
      dispatch(unselectedCategory(null));
      setEndIndex(20);
      // dispatch(setMerchants(data));
    }
  }

  function handleSelectSubCategory(event) {
    let name = event.params.data.id;

    if (selected_subcategory != name && !(selected_subcategory === null && name === "ทัั้งหมด")) {
      dispatch(setSelectedSubCategory(name));
      dispatch(filterSubCategory(name));
      setEndIndex(20);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "track_event",
        event_category: "link_click",
        event_action: "click",
        event_label: name,
      });
    }
  }
  function handleClickCategory(name) {
    if (tippyInstanceRef.current !== null) {
      if (tippyInstanceRef.current.length > 0) {
        tippyInstanceRef.current[0].hide();
      }
    }

    if (selected_category != name) {
      dispatch(setSelectedCategory(name));
      dispatch(filterCategory(name));
      setEndIndex(20);
    }

    if (name == "ทั้งหมด") {
      dispatch(setSelectedCategory(null));
      setEndIndex(20);
    }
  }

  function handleSearch(event) {
    setIsClickOutSide(false);

    let search_term = event.target.value;
    setSearchTerm(search_term);

    if (search_term.length >= 4) {
      dispatch(setSearch(search_term));
    }

    if (search_term.length == 0) {
      dispatch(clearSearch());
      setEndIndex(20);
      setSearchTerm("");
    }
  }

  function handleSearchSubmit() {
    dispatch(setSearch(searchTerm));
  }

  function handleKeyDown(event) {
    if (event.key === "Enter") {
      dispatch(setSearch(searchTerm));
    }
  }

  function handleClear() {
    dispatch(clearSearch());
    setEndIndex(20);
    setSearchTerm("");
  }

  function handleClickMerchant(merchant, e) {
    setShowMerchant(merchant);
    e.preventDefault();

    $.magnificPopup.open({
      items: [
        {
          src: alertPopup,
        },
      ],
      type: "inline",
      overflowY: "scroll",
      closeMarkup:
        '<button type="button" class="mfp-close"><i class="ic-npa ic-npa-icon-plus"></i></button>',
      autoFocusLast: false,
      fixedContentPos: true,
    });
    $(".mfp-content .btn-cancel").on("click", function () {
      $.magnificPopup.close();
      e.preventDefault();
      setShowMerchant(null);
    });
    $(".mfp-content .btn-confirm").on("click", function () {
      $.magnificPopup.close();
      setShowMerchant(null);
    });
  }

  function handleBlur() {
    setIsClickOutSide(true);
  }

  function handleCancelBtn(e) {
    console.log("🚀 ------------------------------------------------🚀");
    console.log("🚀 ~ file: Index.js:330 ~ handleCancelBtn ~ e:", e);
    console.log("🚀 ------------------------------------------------🚀");

    e.preventDefault();
  }

  if (isLoading) {
    // return skeleton loader
    return (
      <div className="g-load-div">
        <div className="g-loader-wrapper">
          <div className="g-loader" />
          <div className="g-loader-caption">{WORDS.LOADING}</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div id="page-playlater-map" className="icw">
        {/* MAIN : START */}
        <main className="main">
          <section id="bar-product-detail" data-dl-section="highlight" className="d-none">
            <div className="kp-container">
              <span className="pd-ic">
                <span className="ic-name">{WORDS.PRODUCT_NAME}</span>
              </span>
              <a
                href="/th/personal/loan/personalloan/pages/kpaylater.aspx"
                className="pd-btn pxtm-click-linkClick"
                title="ดูรายละเอียดผลิตภัณฑ์"
              >
                {WORDS.PRODUCT_DETAIL}
                <br />
                {WORDS.PRODUCT_NAME.toUpperCase()}
              </a>
            </div>
          </section>
          {showBar3 && <nav
            id="navigation-page-sticky"
            class="stickyNav cloak"
            data-mode="json"
            data-ref="th_personal_kpaylater-map.json"
          ></nav>}
          <section id="section-search">
            <div className="search-box-wrapper">
              <h1>
                {WORDS.MERCHANT_JOIN}
                <span className="green">{WORDS.PRODUCT_NAME.toUpperCase()}</span>
              </h1>
              <h2>
                {WORDS.MERCHANT_SEARCH}
                <br className="show-xs" /> {WORDS.MERCHANT_MAP}
              </h2>
              <div className="search-box">
                <div className="input-search-result">
                  <input
                    type="text"
                    className="search-result"
                    placeholder={WORDS.MERCHANT_NAME}
                    autoComplete="off"
                    onChange={handleSearch}
                    onBlur={handleBlur}
                    value={searchTerm}
                    onKeyDown={handleKeyDown}
                  />
                  {searchTerm && <span className="ic-close-suggestion" onClick={handleClear} />}
                </div>
                <span
                  className="ic-search"
                  title="search"
                  onClick={handleSearchSubmit}
                />
              </div>
            </div>
            {search != "" && searchTerm != "" && !isClickOutSide && (
              <div className="suggestion-box">
                <div>
                  <div className="suggestion-text-box">
                    {filter_merchants?.length > 0 &&
                      filter_merchants?.slice(0, 5).map((m) => (
                        <a href="#" className="suggestion-text">
                          <p>{m.nm_en}</p> {m.nm_th}
                        </a>
                      ))}
                  </div>
                </div>
              </div>
            )}
          </section>
          <section id="search-fix-bar">
            <div className="search-fix-wrapper">
              <div className="search-box">
                <div className="input-search-result">
                  <input
                    type="text"
                    className="search-result"
                    placeholder={WORDS.MERCHANT_NAME}
                    defaultValue=""
                    autoComplete="off"
                  />
                  <div className="clear-data-row" style={{ display: "none" }}>
                    <div className="clear-data">
                      <img
                        src="/SiteCollectionDocuments/personal/loan/personal-loan/paylater-map/img/clear-data-gray.svg"
                        width={15}
                        alt="ล้างการค้นหา"
                      />
                      <span className="tooltip-clear" style={{ display: "none" }}>
                        เคลียร์
                      </span>
                    </div>
                  </div>
                  <span className="ic-close-suggestion" style={{ display: "none" }} />
                </div>
                <span className="ic-search" />
              </div>
            </div>
          </section>
          <section id="section-result">
            <div className="kp-container">
              <div className="kp-nav-wrap">
                <div className="category-tab-wrapper">
                  <div id="category-nav" className="category-nav-wrap">
                    <ul className="nav kp-nav">
                      {categories?.map((c, i) => (
                        <li
                          className="kp-nav-item"
                          role="tab"
                          // onClick={() => handleSelectCategory(c.cate_th)}
                        >
                          <a
                            href="#"
                            className={`kp-nav-link pxtm-click-barTab ${
                              selected_category == c.cate_th ||
                              (categories[0].cate_th == c.cate_th && selected_category == null)
                                ? "active"
                                : ""
                            }`}
                            data-bs-toggle="pill"
                            aria-selected="true"
                            onClick={() => handleSelectCategory(c.cate_th)}
                            key={`category-a-${i}`}
                          >
                            {c.cate_logo != "" && <i className={c.cate_logo} />}
                            <span>{c.cate_th}</span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  {/* toggle */}
                  <div id="categoryTabToggle" className="category-tab-toggle">
                    <div className="category-tab-toggle-active-label">
                      กรุณาเลือกหมวดหมู่ที่ต้องการ
                    </div>
                    <div
                      className="category-tab-toggle-button pxtm-click-toggleDetail"
                      ref={tooltipRef}
                      title="กรุณาเลือกหมวดหมู่ที่ต้องการ"
                    ></div>
                    {
                      <div id="categoryTabToggleContent" ref={toggleRef}>
                        <div className="container">
                          <ul>
                            {categories?.map((category, i) => (
                              <li
                                className={`kp-nav-item ${
                                  selected_category == category.cate_th ||
                                  (categories[0].cate_th == category.cate_th &&
                                    selected_category == null)
                                    ? "active"
                                    : ""
                                }`}
                                role="tab"
                                key={`category-li-${i}`}
                              >
                                <a
                                  href="#"
                                  className={`kp-nav-link pxtm-click-barTab ${
                                    selected_category == category.cate_th ||
                                    (categories[0].cate_th == category.cate_th &&
                                      selected_category == null)
                                      ? "active"
                                      : ""
                                  }`}
                                  data-bs-toggle="pill"
                                  aria-selected="true"
                                  onClick={() => handleClickCategory(category.cate_th)}
                                  key={`category-toggle-li-${i}`}
                                >
                                  {category.cate_logo != "" && <i className={category.cate_logo} />}
                                  <span>{category.cate_th}</span>
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    }
                  </div>
                  {/* </div> */}
                </div>
                <div
                  className="kp-result popular"
                  style={{
                    display: search != "" || search == null ? "none" : "block",
                  }}
                >
                  <div className="result-header">
                    <h2>
                      {selected_category
                        ? selected_category + WORDS.POPULAR_MERCHANT
                        : WORDS.MERCHANT + WORDS.POPULAR_MERCHANT}
                    </h2>
                  </div>
                  <div className="list-result">
                    {selected_category || search || selected_subcategory
                      ? filter_popular_merchants?.slice(0, endIndexPopular)?.map((merchant, i) => (
                          <a
                            href={void 0}
                            className="list-result-item pxtm-click-linkClick"
                            key={`list-result-item-${i}`}
                            onClick={(e) => handleClickMerchant(merchant, e)}
                          >
                            <div>
                              <img
                                src={
                                  merchant.logo != ""
                                    ? WORDS.PATH_LOGO + merchant.logo
                                    : WORDS.PATH_LOGO + WORDS.DEFAULT_LOGO
                                }
                                alt={merchant.logo}
                              />
                            </div>
                            <span>{merchant.nm_en}</span>
                          </a>
                        ))
                      : default_popular?.slice(0, endIndexPopular)?.map((merchant, i) => (
                          <a
                            href={void 0}
                            className="list-result-item pxtm-click-linkClick"
                            key={`popular-a-${i}`}
                            onClick={(e) => handleClickMerchant(merchant, e)}
                          >
                            <div>
                              <img
                                src={
                                  merchant.logo != ""
                                    ? WORDS.PATH_LOGO + merchant.logo
                                    : WORDS.PATH_LOGO + WORDS.DEFAULT_LOGO
                                }
                                alt={merchant.logo}
                              />
                            </div>
                            <span>{merchant.nm_en}</span>
                          </a>
                        ))}
                    {hasMoreItemsPopular && (
                      <div className="loadmore-btn">
                        {isLoadingMorePopular ? (
                          <div className="g-load-div">
                            <div className="g-loader-wrapper">
                              <div className="g-loader" />
                              <div className="g-loader-caption">{WORDS.LOAD_MORE}</div>
                            </div>
                          </div>
                        ) : (
                          <button onClick={handleLoadMorePopular} disabled={isLoadingMorePopular}>
                            <a href={void 0} className="loadmore">
                              {WORDS.LOAD_MORE}
                            </a>
                          </button>
                          //   <a href={void(0)} onClick={handleLoadMorePopular} disabled={isLoadingMorePopular}>
                          //   {WORDS.LOAD_MORE}
                          // </a>
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <div className="kp-result">
                  <div className="result-header">
                    <div>
                      <div className="result-header-normal">
                        <h2>
                          {selected_category
                            ? selected_category + WORDS.ALL_MERCHANT
                            : WORDS.MERCHANT + WORDS.ALL_MERCHANT}
                        </h2>
                      </div>
                      {search && (
                        <div className="result-header-search">
                          <h2>
                            {WORDS.SEARCH_RESULT}
                            <strong className="green"> "{search}"</strong>
                          </h2>
                          <div className="sum-result">
                            {WORDS.SEARCH_RESULT_AMOUNT +
                              " " +
                              filter_merchants?.length +
                              " " +
                              WORDS.SEARCH_RESULT_ROWS}
                          </div>
                        </div>
                      )}
                    </div>
                    <SelectList
                      name="category"
                      id="category"
                      className="select-category"
                      ref={selectRef}
                      hideEmpty={true}
                      placeholder={WORDS.VIEW_ALL}
                      OnformsDataChange={handleSelectSubCategory}
                      value={selected_subcategory ? selected_subcategory : "ทั้งหมด"}
                      option={subcategories.map((m) => ({
                        value: m,
                        text: m,
                      }))}
                    ></SelectList>
                  </div>
                  <div className="list-result">
                    {selected_category ||
                    search ||
                    selected_subcategory ||
                    filter_merchants?.length > 0
                      ? filter_merchants?.slice(0, endIndex).map((merchant, i) => (
                          <a
                            href={void 0}
                            className="list-result-item pxtm-click-linkClick"
                            key={`filter-a-${i}`}
                            onClick={(e) => handleClickMerchant(merchant, e)}
                          >
                            <div>
                              <img
                                src={
                                  merchant.logo != ""
                                    ? WORDS.PATH_LOGO + merchant.logo
                                    : WORDS.PATH_LOGO + WORDS.DEFAULT_LOGO
                                }
                              />
                            </div>
                            <span>{merchant.nm_en}</span>
                          </a>
                        ))
                      : merchants.slice(0, endIndex).map((merchant, i) => (
                          <a
                            href={void 0}
                            className="list-result-item pxtm-click-linkClick"
                            key={`filter-popular-${i}`}
                            onClick={(e) => handleClickMerchant(merchant, e)}
                          >
                            <div>
                              <img
                                src={
                                  merchant.logo != ""
                                    ? WORDS.PATH_LOGO + merchant.logo
                                    : WORDS.PATH_LOGO + WORDS.DEFAULT_LOGO
                                }
                              />
                            </div>
                            <span>{merchant.nm_en}</span>
                          </a>
                        ))}
                  </div>
                  {/* {isLoadingMore && (
                    <div className="g-load-div">
                      <div className="g-loader-wrapper">
                        <div className="g-loader" />
                        <div className="g-loader-caption">{WORDS.LOAD_MORE}</div>
                      </div>
                    </div>
                  )} */}
                  {hasMoreItems ? (
                    <div className="loadmore-btn">
                      {isLoadingMore ? (
                        <div className="g-load-div">
                          <div className="g-loader-wrapper">
                            <div className="g-loader" />
                            <div className="g-loader-caption">{WORDS.LOAD_MORE} </div>
                          </div>
                        </div>
                      ) : (
                        <button onClick={handleLoadMore} disabled={isLoadingMore}>
                          <a href={void 0} className="loadmore">
                            {WORDS.LOAD_MORE}
                          </a>
                        </button>
                      )}
                    </div>
                  ) : (
                    searchTerm != "" &&
                    filter_merchants?.length == 0 && (
                      <div style={{ textAlign: "center" }}>{WORDS.NOT_FOUND} </div>
                    )
                  )}
                </div>

                <div class="text-note">
                  <span>
                    ธนาคารไม่มีส่วนเกี่ยวข้องกับสินค้า/บริการ หากมี<span class="nw">ข้อสงสัย</span>
                    หรือข้อขัดข้องประการใด โปรดติดต่อผู้จำหน่าย/<span class="nw">ผู้ให้บริการ</span>
                    โดยตรง
                  </span>
                </div>

                {/* Popup */}
                <div
                  className="mfp-hide white-popup icw alert-to-map"
                  // ref={alertPopup}
                >
                  <div>
                    <div className="popop-logo">
                      <img
                        src={
                          showMerchant?.logo != ""
                            ? WORDS.PATH_LOGO + showMerchant?.logo
                            : WORDS.PATH_LOGO + WORDS.DEFAULT_LOGO
                        }
                        alt="logo"
                      />
                      <span>{showMerchant?.nm_en}</span>
                    </div>
                    <div className="popup-caption">
                      <div>
                        {showMerchant?.l_gg != "" && showMerchant?.l_web != ""
                          ? WORDS.REDIRECT_TXT
                          : showMerchant?.l_gg == "" && showMerchant?.l_web == ""
                          ? WORDS.NO_LINK_TXT
                          : showMerchant?.l_gg == "" && showMerchant?.l_web != ""
                          ? WORDS.WEB_LINK_TXT
                          : WORDS.GG_LINK_TXT}
                      </div>
                      <div>
                        <strong>
                          {(showMerchant?.l_gg != "" && showMerchant?.l_web != "") ||
                          (showMerchant?.l_gg == "" && showMerchant?.l_web == "")
                            ? WORDS.NO_TXT
                            : WORDS.PRESS_TO_CONFIRM}
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div className="popup-btn-box">
                    <a
                      href="javascript:;"
                      className="popup-btn btn-cancel"
                      // id="btn-cancel"
                      // onClick={handleCancelBtn}
                    >
                      {showMerchant?.l_gg == "" && showMerchant?.l_web == ""
                        ? WORDS.CLOSE_BTN
                        : WORDS.CANCEL_BTN}
                    </a>
                    {showMerchant?.l_gg != "" && showMerchant?.l_web != "" && (
                      <>
                        <a
                          href={showMerchant?.l_gg}
                          className="popup-btn btn-confirm pxtm-click-linkClick"
                          title={`Google_Maps_${showMerchant?.nm_en}`}
                          target="_blank"
                          // onClick={handleClickPopup}
                        >
                          {WORDS.GG_BTN}
                        </a>
                        <a
                          href={showMerchant?.l_web}
                          className="popup-btn btn-confirm pxtm-click-linkClick"
                          title={`เว็บไซต์ร้านค้า_${showMerchant?.nm_en}`}
                          target="_blank"
                          // onClick={handleClickPopup}
                        >
                          {WORDS.WEB_BTN}
                        </a>
                      </>
                    )}
                    {showMerchant?.l_web != "" && showMerchant?.l_gg == "" && (
                      <a
                        href={showMerchant?.l_web}
                        className="popup-btn btn-confirm  pxtm-click-linkClick"
                        title={`เว็บไซต์ร้านค้า_${showMerchant?.nm_en}`}
                        target="_blank"
                        // onClick={handleClickPopup}
                      >
                        {WORDS.CONFIRM_BTN}
                      </a>
                    )}
                    {showMerchant?.l_web == "" && showMerchant?.l_gg != "" && (
                      <a
                        href={showMerchant?.l_gg}
                        className="popup-btn btn-confirm pxtm-click-linkClick"
                        title={`Google_Maps_${showMerchant?.nm_en}`}
                        target="_blank"
                        // onClick={handleClickPopup}
                      >
                        {WORDS.CONFIRM_BTN}
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};
// $('header.header, footer').addClass('hide');
const getURLParameter = function (name) {
  name = name.toLowerCase();
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.search.toLowerCase()
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
};

$(function () {
  var getKPLUS = getURLParameter("app");
  if (getKPLUS !== null && getKPLUS.toLocaleLowerCase() == "kplus") {
    $("header.header, footer").hide();
    $(".chat-list").hide();
    // prod
    $(".header-top").hide();
    $(".footer-main").hide();
    $("html").addClass("kplus-hide-webchat");
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("react-app-kpaylater")
);

if (module.hot) {
  module.hot.accept();
}

console.log("react app property template start");
